import React, { useEffect } from "react";
import { IOMode, IOType } from "../../../IO/types";
import Deposit, { DepositValidations } from "./Deposit/Deposit";
import Withdrawal, { WithdrawalValidations } from "./Withdrawal/Withdrawal";
import { Redemption, RedemptionValidations } from "./Redemption/Redemption";
import { Subscription, SubscriptionValidations } from "./Subscription/Subscription";
import Transfer, { TransferValidations } from "./Transfer/Transfer";
import DepositBulk from "./Deposit/DepositBulk";
import WithdrawalBulk from "./Withdrawal/WithdrawalBulk";
import style from "../IO.module.scss";

export const isEmpty = (value) => value == undefined || value == "" || value == 0;

const Default = ({ ioType, ioMode, account, opsViewAccountName, disableACSelector }) => {

  if (ioType == IOType.Deposit) {
    return (
      <div className={style.form}>{ioMode == IOMode.MultipleAssets ? <DepositBulk opsViewAccountName={opsViewAccountName}/> : <Deposit />}</div>
    );
  }

  if (ioType == IOType.Withdraw) {
    return (
      <div className={style.form}>
        {ioMode == IOMode.MultipleAssets ? <WithdrawalBulk opsViewAccountName={opsViewAccountName} disableACSelector={disableACSelector} /> : <Withdrawal disableACSelector={disableACSelector} />}
      </div>
    );
  }

  if (ioType == IOType.Subscription) {
    return (
      <div className={style.form}>
        <Subscription account={account} />
      </div>
    );
  }

  if (ioType == IOType.Redemption) {
    return (
      <div className={style.form}>
        <Redemption account={account} />
      </div>
    );
  }

  if (ioType == IOType.Transfer) {
    return (
      <div className={style.form}>
        <Transfer opsViewAccountName={opsViewAccountName} />
      </div>
    );
  }
};

export const updateAccountBanks = (accountId, currencyId, dispatch, fetchGetAccountBanks) => {
  fetchGetAccountBanks({ accountId, currencyId })
    .then((r) => r.response)
    .then((r) => {
      dispatch({ type: "UPDATE_ACCOUNT_BANKS", accountBanks: r.accountBanks });
    });
};

export function validations(io, userType) {
  let validations = {};

  if (io.IOType == IOType.Deposit) {
    validations = DepositValidations(io, userType);
  } else if (io.IOType == IOType.Withdraw) {
    validations = WithdrawalValidations(io);
  } else if (io.IOType == IOType.Redemption) {
    validations = RedemptionValidations(io);
  } else if (io.IOType == IOType.Subscription) {
    validations = SubscriptionValidations(io);
  } else if (io.IOType == IOType.Transfer) {
    validations = TransferValidations(io);
  }

  return {
    ...validations.form,
    simple: {
      ...validations.simple,
    },
    subForm: {
      ...validations.subForm,
    },
  };
}

export default Default;
